import { Currency, PlanType, SubscriptionFrequency, Brand, FoodType } from '@calo/types';
import PlanService from './PlanService';
import FoodService from './FoodService';
import PricingService from './PricingService';
import { CALO_FOOD_TYPE_PRICING } from './constants';
import { CALO_PLAN_RAMADAN_DISCOUNT } from './constants';
class DeliveryService {
    getFoodPrice(food, diet, currency, brand, magicPrice) {
        let cost = 0;
        if (!food.tags.includes(diet)) {
            diet = FoodService.getDiet(food);
        }
        if ((food === null || food === void 0 ? void 0 : food.isCustom) && (food === null || food === void 0 ? void 0 : food.price)) {
            cost += food.price;
        }
        const planService = magicPrice ? new PlanService(brand, true) : new PlanService(brand);
        cost += planService.getFoodTypePrice(food.type[0], diet, currency);
        return cost;
    }
    getFoodCost(food, addons, dietType, planType, frequency, currency, brand, foodType, magicPrice) {
        var _a, _b;
        let cost = 0;
        const planService = magicPrice ? new PlanService(brand, true) : new PlanService(brand);
        if (food.length === 0 && addons.length === 0) {
            const currentPlan = planService.getPlan({
                currency,
                dietType,
                foodType,
                frequency,
                planType
            });
            return currentPlan.pricePerDay;
        }
        for (let f of food) {
            if (!f.skipped) {
                cost += this.getFoodPrice(f, dietType, currency, brand, magicPrice ? true : false);
            }
        }
        if (brand === Brand.MEALO) {
            if (frequency === SubscriptionFrequency.weekly) {
                cost += 1;
            }
            else if (frequency === SubscriptionFrequency.monthly && planType === PlanType.businessLunch) {
                cost += 0.5;
            }
        }
        else {
            for (let a of addons) {
                if ((!a.price && !a.currency) || a.currency !== currency || a.isGifted) {
                    continue;
                }
                else if (a.addedAs && a.addedAs === 'meal') {
                    cost += this.getFoodPrice(a, dietType, currency, brand, magicPrice ? true : false);
                }
                else {
                    cost += a.price;
                }
            }
            if (planType === PlanType.businessLunch) {
                switch (currency) {
                    case Currency.SAR:
                        cost += 2;
                        break;
                }
            }
            if (![PlanType.ramadan, PlanType.futoor, PlanType.custom].includes(planType)
                && currency === Currency.KWD
                && food.filter(food => food.type.includes(FoodType.snack)).length >= 2) {
                cost -= CALO_FOOD_TYPE_PRICING[dietType][FoodType.snack][Currency.KWD];
            }
            if (planType === PlanType.ramadan || planType === PlanType.futoor) {
                cost -= ((_b = (_a = CALO_PLAN_RAMADAN_DISCOUNT === null || CALO_PLAN_RAMADAN_DISCOUNT === void 0 ? void 0 : CALO_PLAN_RAMADAN_DISCOUNT[currency]) === null || _a === void 0 ? void 0 : _a[dietType]) === null || _b === void 0 ? void 0 : _b[planType]) || 0;
            }
            if (!magicPrice) {
                cost -= (frequency === SubscriptionFrequency.monthly && planType === PlanType.full && currency === Currency.BHD) ? 1 : 0;
            }
            if (frequency === SubscriptionFrequency.weekly) {
                switch (currency) {
                    case Currency.BHD:
                        cost += 1;
                        break;
                    case Currency.SAR:
                        cost += 10;
                        break;
                    case Currency.AED:
                        cost += 10;
                        break;
                    case Currency.KWD:
                        cost += 1;
                        break;
                    case Currency.OMR:
                        cost += 1;
                        break;
                    default:
                        cost += 1;
                }
            }
        }
        return PricingService.roundAmount(cost, currency);
    }
}
export default new DeliveryService();
